import { render, staticRenderFns } from "./MultiStepFormDialog.vue?vue&type=template&id=2bca1e5a&scoped=true&"
import script from "./MultiStepFormDialog.vue?vue&type=script&lang=js&"
export * from "./MultiStepFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepFormDialog.vue?vue&type=style&index=0&id=2bca1e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca1e5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSelect,VTextField,VTooltip})
